import React from 'react';
import styled from 'styled-components';
import { LISTING_FEE_TIERS } from '../../constants/onboardingContent';

const Box = styled.div`
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 0.85rem;
  padding: 1rem 1.15rem;
  margin-bottom: 1.25rem;
`;

const Headline = styled.p`
  margin: 0 0 0.5rem;
  font-weight: 800;
  color: #065f46;
  font-size: 0.95rem;
`;

const Sections = styled.p`
  margin: 0 0 0.65rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #059669;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 1.1rem;
  color: #047857;
  font-size: 0.84rem;
  line-height: 1.55;
`;

export default function ListingFeeCallout({ tier = 'personal' }) {
  const config = LISTING_FEE_TIERS[tier] || LISTING_FEE_TIERS.personal;

  return (
    <Box role="note" aria-label="Listing fees">
      <Sections>{config.sections}</Sections>
      <Headline>{config.headline}</Headline>
      <List>
        {config.bullets.map((bullet) => (
          <li key={bullet}>{bullet}</li>
        ))}
      </List>
    </Box>
  );
}
